<template lang='pug'>
  v-dialog(v-model='dialog' scrollable persistent max-width='80%')
        v-card(color='grey_1')
          v-app-bar(dark color='primary')
            span.headline {{ formTitle }}
          v-card-text
            v-row(dense)
              v-col(cols='12')
                v-card(color='white')
                  v-card-text
                    v-row(dense)
                      v-col(cols='12' sm='12' md='4')
                        v-text-field(v-model='factura' id="facturaPago" outlined readonly  label='Número de Factura'  dense)
                      v-col(cols='12' sm='12' md='12')
                        v-data-table.elevation-1(:headers='headers' :items='pagos' :search='search' :loading='loading' loading-text='Cargando, por favor espere...')
                          template(v-slot:top)
                            v-toolbar(flat color='primary' dark)
                              v-toolbar-title Pagos
                              v-divider.mx-4(inset vertical)
                              v-spacer
                              v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
                              v-spacer
                          //- template(v-slot:item.action='{ item }')
                          //-   v-icon.mr-2(color='indigo' @click='editItem(item)') mdi-format-list-checkbox
                          template(v-slot:no-data)
                            h1 No hay Pagos Asociados
          v-card-actions
            v-spacer
            v-btn(color='error' small dark @click='close')
              v-icon mdi-close
              | Cancelar
</template>

<script>
import Api from '@/services/methods'
import PagoFacturaClienteM from '@/components/modals/PagoFacturaClienteM'
export default {
  props: ['dialog', 'FormPadre', 'pagos', 'factura'],
  data: () => ({
    loading: true,
    search: '',
    headers: [
      { text: 'Descripcion', align: 'center', sortable: false, value: 'descripcion' },
      { text: 'Forma de pago', align: 'center', sortable: false, value: 'idTipoPago.descripcion' },
      { text: 'Concepto', align: 'center', sortable: false, value: 'idConcepto.nombre' },
      { text: 'Fecha Cobro', align: 'center', sortable: false, value: 'fechaCobro' },
      { text: 'Fecha Registro', align: 'center', sortable: false, value: 'fechaRegistro' },
      { text: 'Monto', align: 'center', sortable: false, value: 'monto' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    facturaPag: {},
    form: {},
    defaultItem: {}
  }),
  components: {
    PagoFacturaClienteM
  },
  computed: {
    formTitle () {
      return 'Pagos Asociados'
    }
  },
  watch: {
    FormPadre (val) {
      // formulario que llega del padre, para editar y ver
      if (Object.keys(val).length !== 0) {
        this.form = val
        this.loading = false

      }
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
    },

    close () {
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultItem)
      }, 300)
      this.$emit('close')
    }
  }
}
</script>
